import { useEffect, useState } from 'react';
import { FiTrash2, FiPlus } from 'react-icons/fi';
import { getBanners, createBanner, updateBanner, deleteBanner, resolveImages } from '../../api';
import ImageUploader from '../../components/admin/ImageUploader';
import { useToast } from '../../components/Toast';
import Loader from '../../components/Loader';

const blank = { title: '', subtitle: '', ctaText: '', ctaLink: '', order: 0, image: [] };

export default function AdminBanners() {
  const [banners, setBanners] = useState(null);
  const [form, setForm] = useState(blank);
  const [saving, setSaving] = useState(false);
  const { toast, ToastHost } = useToast();

  const load = () => getBanners().then(setBanners).catch(() => setBanners([]));
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const add = async (e) => {
    e.preventDefault();
    if (!form.image.length) return toast('Please add a banner image', 'error');
    setSaving(true);
    try {
      const [image] = await resolveImages(form.image);
      await createBanner({ ...form, image, order: Number(form.order) || 0 });
      toast('Banner added');
      setForm(blank);
      load();
    } catch (err) { toast('Failed to add banner', 'error'); }
    finally { setSaving(false); }
  };

  const toggleActive = async (b) => {
    await updateBanner(b._id, { active: !b.active });
    load();
  };

  const remove = async (b) => {
    if (!window.confirm('Delete this banner?')) return;
    await deleteBanner(b._id);
    toast('Banner deleted');
    load();
  };

  if (!banners) return <Loader />;

  return (
    <div>
      <div className="acontent__head"><h1>Banners <span className="muted" style={{ fontSize: 16 }}>({banners.length})</span></h1></div>

      <form className="acard" onSubmit={add}>
        <h3><FiPlus /> Add banner</h3>
        <div className="form-grid">
          <div className="field"><label>Title</label><input className="input" value={form.title} onChange={(e) => set('title', e.target.value)} placeholder="Headline" /></div>
          <div className="field"><label>Subtitle</label><input className="input" value={form.subtitle} onChange={(e) => set('subtitle', e.target.value)} placeholder="Supporting text" /></div>
          <div className="field"><label>Button text</label><input className="input" value={form.ctaText} onChange={(e) => set('ctaText', e.target.value)} placeholder="Shop Now" /></div>
          <div className="field"><label>Button link</label><input className="input" value={form.ctaLink} onChange={(e) => set('ctaLink', e.target.value)} placeholder="/products" /></div>
          <div className="field"><label>Order</label><input className="input" type="number" value={form.order} onChange={(e) => set('order', e.target.value)} /></div>
          <div className="field full"><label>Image <span className="req">*</span></label><ImageUploader value={form.image} onChange={(v) => set('image', v)} multiple={false} label="Upload banner image (wide)" /></div>
        </div>
        <button className="btn btn-primary" disabled={saving}>{saving ? 'Adding…' : 'Add Banner'}</button>
      </form>

      <div className="grid grid-2">
        {banners.map((b) => (
          <div key={b._id} className="acard" style={{ margin: 0, padding: 0, overflow: 'hidden' }}>
            <img src={b.image} alt={b.title} style={{ width: '100%', height: 160, objectFit: 'cover' }} />
            <div style={{ padding: 16 }}>
              <div className="between">
                <strong>{b.title || '(no title)'}</strong>
                <span className={`pill ${b.active ? 'closed' : 'read'}`}>{b.active ? 'Active' : 'Hidden'}</span>
              </div>
              <p className="muted" style={{ fontSize: 14, margin: '6px 0 12px' }}>{b.subtitle}</p>
              <div className="flex gap center">
                <button className={`toggle ${b.active ? 'on' : ''}`} onClick={() => toggleActive(b)} />
                <span className="muted" style={{ fontSize: 13 }}>Visible</span>
                <div style={{ flex: 1 }} />
                <button className="icon-btn danger" onClick={() => remove(b)}><FiTrash2 /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <ToastHost />
    </div>
  );
}
